import React, { useEffect } from "react";
import { Link } from "react-router-dom";


const Privacy = () => { 
    const scrollToTop = () => {
        window.scrollTo(0, 0);
    };


    return (
        <>
            <section className="legal-page" id="privacy">
                <div className="container">
                    <div className="legal-header">
                        <h1>Privacy Policy</h1>
                        <p className="last-updated">Last updated: October 13, 2025</p>
                    </div>

                    <div className="legal-content">
                        <section className="legal-section">
                            <h2>1. Introduction</h2>
                            <p>
                                This Privacy Policy explains how FeeZaap collects and protects
                                user data in compliance with DPDP Act 2023.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>2. Information We Collect</h2>
                            <ul>
                                <li>Student and parent details</li>
                                <li>Payment and transaction data</li>
                                <li>App usage and device data</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>3. Data Usage</h2>
                            <p>
                                Data is used strictly for service delivery, payments, and
                                communication.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>4. Data Security</h2>
                            <p>
                                We use encryption and access controls to protect your data.
                            </p>
                        </section>

                        <section className="legal-section">
                            <h2>5. Your Rights</h2>
                            <ul>
                                <li>Access your data</li>
                                <li>Request correction or deletion</li>
                                <li>Withdraw consent</li>
                            </ul>
                        </section>

                        <section className="legal-section">
                            <h2>6. Contact</h2>
                            <p>
                                Email:{" "}
                                <a href="mailto:mailus@feezaap.com">mailus@feezaap.com</a>
                            </p>
                        </section>
                    </div>
                </div>
            </section>

            {/* <footer className="footer">
                <div className="container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <div className="footer-logo">
                                <img src="/assets/images/feezaap-logo.png" alt="FeeZaap Logo" />
                                <span>FeeZaap</span>
                            </div>
                            <p>Revolutionizing dance school fee management with secure, digital solutions.</p>
                        </div>

                        <div className="footer-section">
                            <h3>Quick Links</h3>
                            <ul>
                                <li><a href="#home">Home</a></li>
                                <li><a href="#features">Features</a></li>
                                <li><a href="#clients">Clients</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#contact">Contact</a></li>
                                <li><a href="#">Login</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Legal</h3>
                            <ul>
                                <li>
                                    <Link to="/terms" onClick={scrollToTop}>
                                        Terms & Conditions
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/privacy" onClick={scrollToTop}>
                                        Privacy Policy
                                    </Link>
                                </li>

                                <li><a href="https://napeans.com" target="_blank" rel="noopener noreferrer">Napeans Technologies</a></li>
                            </ul>
                        </div>

                        <div className="footer-section">
                            <h3>Download App</h3>
                            <div className="app-buttons">
                                <a href="https://play.google.com/store" className="app-button" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-google-play"></i>
                                    <span>Play Store</span>
                                </a>
                                <a href="https://apps.apple.com" className="app-button" target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-app-store-ios"></i>
                                    <span>App Store</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>
                            &copy; 2025 FeeZaap by <a href="https://napeans.com" target="_blank" rel="noopener noreferrer">Napeans Technologies</a>. All rights reserved.
                        </p>
                    </div>
                </div>
            </footer> */}
        </>
    );
};

export default Privacy;
